import { API } from "../../../beans";

export enum ConfirmActionEnum {
  REQUEST = "app/CONFIRM/REQUEST",
  SUCCESS = "app/CONFIRM/SUCCESS",
  FAIL = "app/CONFIRM/FAIL",
}

export interface IConfirmRequest {
  type: ConfirmActionEnum.REQUEST;
  hash: string;
  confirmCode: string;
}
export interface IConfirmSuccess {
  type: ConfirmActionEnum.SUCCESS;
  data: API.Confirm;
}
export interface IConfirmFail {
  type: ConfirmActionEnum.FAIL;
  err: Error;
}

export type ConfirmAction = IConfirmRequest | IConfirmSuccess | IConfirmFail;

export function confirmRequest(
  hash: string,
  confirmCode: string,
): IConfirmRequest {
  return {
    type: ConfirmActionEnum.REQUEST,
    hash,
    confirmCode,
  };
}
export function confirmSuccess(data: API.Confirm): IConfirmSuccess {
  return {
    type: ConfirmActionEnum.SUCCESS,
    data,
  };
}
export function confirmFail(err: Error): IConfirmFail {
  return {
    type: ConfirmActionEnum.FAIL,
    err,
  };
}
